import { useMemo } from "react";
import { formatCents, formatUnits } from "../money.js";
import { useI18n } from "./I18nProvider.js";
/**
 * Formateurs liés à la locale i18n active. Les montants suivent la langue
 * d'interface de l'utilisateur et se rafraîchissent quand elle change.
 */
export function useMoneyFormatter() {
    const { locale } = useI18n();
    return useMemo(() => ({
        formatCents: (cents, currency) => formatCents(cents, currency, locale),
        formatUnits: (units, currency) => formatUnits(units, currency, locale),
    }), [locale]);
}
//# sourceMappingURL=useMoneyFormatter.js.map